/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ClientAccessBootstrap,
  ClientAccessBootstrapFromJSON,
  ClientAccessBootstrapFromJSONTyped,
  ClientAccessBootstrapToJSON,
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
} from "./";

/**
 *
 * @export
 * @interface ClientAccessBootstrapControllerResponse
 */
export interface ClientAccessBootstrapControllerResponse {
  /**
   *
   * @type {ClientAccessBootstrap}
   * @memberof ClientAccessBootstrapControllerResponse
   */
  data?: ClientAccessBootstrap;
  /**
   *
   * @type {ErrorResponse}
   * @memberof ClientAccessBootstrapControllerResponse
   */
  error?: ErrorResponse;
}

export function ClientAccessBootstrapControllerResponseFromJSON(json: any): ClientAccessBootstrapControllerResponse {
  return ClientAccessBootstrapControllerResponseFromJSONTyped(json, false);
}

export function ClientAccessBootstrapControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClientAccessBootstrapControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : ClientAccessBootstrapFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function ClientAccessBootstrapControllerResponseToJSON(
  value?: ClientAccessBootstrapControllerResponse | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: ClientAccessBootstrapToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
